import type { Translator } from '@openeducation/oe-rn-shared-types';

import { TranslatorDao } from '../../dao/translator/translator.dao';
import type { Environment } from '../../interfaces';

export abstract class TranslatorService {
  static async getTranslation(
    env: Environment,
    text: string,
    sourceLang: string,
    targetLang: string
  ): Promise<Translator> {
    if (!env || !text || !sourceLang || !targetLang) {
      return Promise.reject(
        new Error('environment, text sourceLang || !targetLang is missing')
      );
    }
    const data = await TranslatorDao.getTranslation(
      env,
      text,
      sourceLang,
      targetLang
    );

    return {
      ...data,
      sourceLang,
      targetLang,
      originalText: text,
    };
  }
}
